var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapseLeftAreaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.43703 0.025473V16.983C3.39149 16.915 2.50751 16.6175 1.8105 16.1075C1.45352 15.861 1.13902 15.5465 0.89249 15.1895C0.305988 14.382 0 13.328 0 12.0615V4.9385C0 2.0145 1.649 0.203992 4.43703 0.025473ZM17 4.9385V12.0615C17 15.1555 15.1555 17 12.0615 17H5.71203V0H12.0615C13.328 0 14.382 0.305988 15.1895 0.89249C15.5465 1.13897 15.861 1.45347 16.1075 1.8105C16.694 2.61796 17 3.67201 17 4.9385ZM9.75383 8.5L11.4787 6.7751C11.7278 6.52607 11.7278 6.12266 11.4787 5.87363C11.2297 5.62461 10.8263 5.62461 10.5773 5.87363L8.40164 8.04927C8.15261 8.29829 8.15261 8.70171 8.40164 8.95073L10.5773 11.1264C10.7018 11.2509 10.8649 11.3131 11.028 11.3131C11.1911 11.3131 11.3542 11.2509 11.4787 11.1264C11.7278 10.8773 11.7278 10.4739 11.4787 10.2249L9.75383 8.5Z",
    fill: "#4F6E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseLeftAreaIcon);
export default __webpack_public_path__ + "static/media/collapse-left-area-icon.875e9075adc2448938063dfa7e9a767a.svg";
export { ForwardRef as ReactComponent };